import { render } from "./AdminRejectWithdrawal.vue?vue&type=template&id=5ae8c924"
import script from "./AdminRejectWithdrawal.vue?vue&type=script&lang=js"
export * from "./AdminRejectWithdrawal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__